import React, { useEffect, useRef, useState } from "react";
import style from "../../soloJourney/solo.module.sass"
import close from "../../../../../assets/svg/solo/editorMax.svg"
import Editor from "@monaco-editor/react";
import { Button } from "antd";
import { generateTypeDefs } from '../../../../../helpers/typedefinitions'
import _ from "lodash";
import { initializeA8FormsTypeDefs } from "../../../../../helpers/typedefinitions/a8forms";

const CompletionCriteriaPopup = (props: any) => {
    const [values, setValues] = useState("")
    const [jsonValues, setJsonValues] = useState("")
    const [isJsonValid, setIsJsonValid] = useState(true);

    useEffect(() => {
        if (props.values) {
            try {
                if (JSON.parse(props.values)) {
                    setValues(props.values)
                }
            } catch {
                setValues(props.values)
            }
        }
    }, [props.values])

  
    const defaultJson = `{
  "type": "object",
  "properties": {
   
  }
}`;
    return (
        <div className={style.popupbox} data-message-node={props.isMessageNode}>
            <div className={style.box}
                key={props.id}
            >
                <div style={{ overflow: "hidden" }}>
                    <div className={style.editorHeader}>
                        <div style={{ display: "flex", padding: 15 }}>
                            <img src={close} alt="close-editor"
                                style={{ height: "20px", cursor: "pointer" }}
                                onClick={props.close}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Editor
                            height="62vh"
                            defaultLanguage="json"
                            defaultValue={defaultJson}
                            value={values}
                            theme="vs-dark" // or "vs-light"
                            onChange={(e: any) => { 
                                setValues(e); setJsonValues(e)
                                try {
                                    if (e) {
                                        JSON.parse(e);
                                    }
                                    setIsJsonValid(true);
                                } catch {
                                    setIsJsonValid(false);
                                }
                                 }}
                            options={{
                                automaticLayout: true,
                                formatOnType: true,
                                formatOnPaste: true,
                            }}
                        />

                        <div style={{ display: "flex", justifyContent: "flex-end", marginRight: 5, padding: "10px" }}>
                            <Button
                                className={style.editorCloseButton}
                                onClick={props.close}
                            >Cancel </Button>
                            <Button
                                className={style.editorSaveButton}
                                disabled={!isJsonValid}
                                onClick={() => {  props.handleExpression(props.id, values || jsonValues && JSON.stringify(jsonValues)); props.close(); }}
                                type="primary"
                            >Save</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompletionCriteriaPopup;